import React from "react";
import { IParagraphAnchorLinkProps } from "./ParagraphAnchorLinkProps";
import { Container } from "./ParagraphAnchorLinkHelpers";

const ParagraphAnchorLink: React.FC<IParagraphAnchorLinkProps> = (props) => {
  return (
    <Container>
      <a
        href="#"
        className="anchor-target"
        id={`paragraph-${props.id}`}
        aria-hidden="true"
      >{`paragraph-${props.id}`}</a>
    </Container>
  );
};

export default ParagraphAnchorLink;
